import React from 'react';
import { media, TransitionMixin } from '../components/helpers';
import styled from 'styled-components';
import Img from 'gatsby-image';
export const HomeBanner = styled.section`
	position: relative;
	max-height: 100vh;
	overflow: hidden;

	.banner-content {
		position: absolute;
		top: 42%;
		left: 0px;
		z-index: 100;
		width: 100%;
		text-align: center;

		${media.large`left: 20px;`};
		h1 {
			color: #fff;
			font-size: 30px;
			margin: 0px;
			font-family: 'Open Sans', sans-serif;
			${media.small`font-size: 60px;`};
			${media.xl`font-size: 80px;`};

			span {
				display: block;
				font-weight: 300;
				font-size: 18px;
				margin-top: 5px;

				${media.small`font-size: 30px;`};
				${media.large`margin-top: 5px;`};
			}
		}
	}
	.overlay {
		background: rgba(0, 0, 0, 0.5);
		position: absolute;
		height: 100%;
		width: 100%;
		top: 0;
		z-index: 50;
	}

	.desktop {
		display: none;
		${media.large`display: block;`};
	}

	.mobile {
		display: block;
		${media.large`display: none;`};
	}

	.bottom-wrap {
		position: absolute;
		text-align: center;
		bottom: 10%;
		width: 100%;
		z-index: 300;
		.arrow-wrap {
			max-width: 10px;
			position: relative;
			transform: rotate(90deg);
			margin: 0 auto;
		}
	}
`;

const HalfBannerWrap = styled.div`
	position: relative;
	height: 300px;

	${media.medium`max-height: 430px;height: 100%; overflow: hidden;`};

	.gatsby-image-wrapper {
		height: 300px;
		${media.medium`height: 100%; `};
	}

	.dark-mobile-overlay {
		background: rgba(0, 0, 0, 0.45);
		width: 100%;
		top: 0px;
		position: absolute;
		height: 100%;
		${media.medium`background: rgba(0, 0, 0, 0.35);`};
	}
	.overlay {
		background: rgba(0, 0, 0, 0.5);
		width: 100%;
		top: 0px;
		position: absolute;
		height: 100%;
		&.dark {
			background: rgba(0, 0, 0, 0.35);
		}
	}

	.content-section {
		position: absolute;
		top: 50%;
		text-align: center;
		width: 100%;
		z-index: 700;
		h1 {
			color: #fff;
			font-size: 40px;
			font-weight: 300;
			margin: 0px;
		}
	}
`;

export const HalfBanner = ({ image, title, dark, mobile }) => {
	console.log(image);
	return (
		<HalfBannerWrap>
			<div className="image-section">
				<Img sizes={image.sizes} />
			</div>
			<div className="content-section">
				<div className="caption">
					<h1>{title}</h1>
				</div>
			</div>
			<div
				className={
					dark
						? 'overlay dark'
						: 'dark' && mobile == true
							? 'dark-mobile-overlay'
							: ''
				}
			/>
		</HalfBannerWrap>
	);
};

export default HalfBanner;



// WEBPACK FOOTER //
// ./src/components/Banners.js